// extracted by mini-css-extract-plugin
export default {"image":"background__image__coNct","color":"background__color__hXZQj","video":"background__video__c5Rh_","videoEnabled":"background__videoEnabled__OLXf4"};